import { ReactNode } from 'react';

import { labelDom, LabelDomProps } from '@/components/Label';
import { PageIds } from '@/const/tip';
import { useTypedSelector } from '@/store';

import styles from './index.module.less';

interface IProps {
  title: string;
  subTitle: string;
  icon: ReactNode;
  fieldProps?: string;
  labelProps?: LabelDomProps;
}

const GameTitle: React.FC<IProps> = (props) => {
  const { title, subTitle, icon } = props;
  const tipList = useTypedSelector(store => store.tip);

  const labelProps: LabelDomProps = {
    field: {
      props: props.fieldProps,
      uiOptions: { labelStyle: { width: 'fit-content', whiteSpace: 'nowrap' } },
    },
    initFormData: '',
    pageId: PageIds.GAME_PLAY,
    tipList,
    ...props.labelProps,
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.text}>
          <div className={styles.title}>{title}</div>
          <div className={styles.subTitle}>{subTitle}</div>
        </div>
      </div>
      {props.fieldProps && labelDom(labelProps, false)}
    </div>
  );
};

export default GameTitle;
